import { render } from "./OrdineMaterialeAppuntamento.vue?vue&type=template&id=df4d669e&scoped=true"
import script from "./OrdineMaterialeAppuntamento.vue?vue&type=script&lang=js"
export * from "./OrdineMaterialeAppuntamento.vue?vue&type=script&lang=js"

import "./OrdineMaterialeAppuntamento.vue?vue&type=style&index=0&id=df4d669e&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df4d669e"]])

export default __exports__